import React from 'react';
import { QuestionStats } from 'src/redux/survey/survey.types';

interface OverviewSidepanelQuestionProps {
  index: number;
  question: QuestionStats;
  onClick?: () => void;
}

const OverviewSidepanelQuestion: React.FC<OverviewSidepanelQuestionProps> = ({
  index,
  question,
  onClick,
}) => {
  return (
    <div
      className="flex flex-row items-center justify-between cursor-pointer hover:ml-2 transition-all duration-300 ease-in-out"
      onClick={onClick}
    >
      <div className="flex flex-row items-center gap-2 border-b border-gray-201 pb-2 mt-2">
        <div className="flex size-4 shrink-0 rounded-full bg-blue-500 items-center justify-center">
          <div className="text-white text-xs">
            {index + 1}
          </div>
        </div>
        <div className="font-light text-gray-800 text-base">
          {question.title}
        </div>
      </div>

    </div>
  );
};

export default OverviewSidepanelQuestion;
